import { Container } from '@mui/material'
import type { JSX } from 'react'

const NotFoundPage = (): JSX.Element => {
  return (
    <Container maxWidth="xl" disableGutters>
      There is nothing here!
    </Container>
  )
}

export default NotFoundPage
